<template>
  <div class="mentionList items">
    <template v-if="items.length">
      <div
        class="item"
        :class="{ 'is-selected': index === selectedIndex }"
        v-for="(item, index) in items"
        :key="index"
        @click="selectItem(index)"
        @mouseenter="setIndex(index)"
      >
        {{ item.fullName }} ({{ item.email }})
      </div>
    </template>
    <div class="item itemNo" v-else>
      "{{ text.substr(1, this.text.length - 1) }}" doesn't seem to be here.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },

    command: {
      type: Function
    },
    query: {
      type: String
    },
    text: {
      type: String
    }
  },

  data() {
    return {
      selectedIndex: 0
    }
  },
  created() {
    console.log(this.props)
    console.log(this.items)
  },

  watch: {
    items() {
      console.log(this.text)
      this.selectedIndex = 0
    }
  },

  methods: {
    setIndex(ind) {
      this.selectedIndex = ind
    },
    onKeyDown({ event }) {
      if (event.key === 'ArrowUp') {
        this.upHandler()
        return true
      }

      if (event.key === 'ArrowDown') {
        this.downHandler()
        return true
      }

      if (event.key === 'Enter') {
        this.enterHandler()
        return true
      }

      return false
    },

    upHandler() {
      this.selectedIndex = (this.selectedIndex + this.items.length - 1) % this.items.length
    },

    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length
    },

    enterHandler() {
      this.selectItem(this.selectedIndex)
    },

    selectItem(index) {
      const item = this.items[index]

      if (item) {
        this.command({ id: item.fullName })
      }
    }
  }
}
</script>

<style lang="less">
.mentionList.items {
  width: 400px;
  max-height: 200px;
  overflow-y: auto;
  position: relative;
  overflow-x: hidden;
  background: #fff;
  border: 1px solid rgb(203, 214, 226);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.items::-webkit-scrollbar-thumb:vertical {
  -webkit-border-radius: 0px;
}

.items::-webkit-scrollbar {
  width: 12px;
  height: 12px;
  border-radius: 0px;
}
.items::-webkit-scrollbar-thumb:horizontal {
  -webkit-border-radius: 0px;
}
.items::-webkit-scrollbar-button {
  width: 6px;
  height: 6px;
  display: block;
  background-color: #eeeeee;
}
.items::-webkit-scrollbar-track {
  background: #eeeeee !important;
}
.items::-webkit-scrollbar-button:horizontal:single-button:start {
  background: url('../../../components/edoovo-components/TableNew/Left Arrow.png') no-repeat center
    #eeeeee;
  cursor: pointer;
}
.items::-webkit-scrollbar-button:horizontal:single-button:end {
  background: url('../../../components/edoovo-components/TableNew/Right Arrow.png') no-repeat center
    #eeeeee;
  cursor: pointer;
}
.items::-webkit-scrollbar-button:vertical:single-button:start {
  background: url('../../../components/edoovo-components/TableNew/Up Arrow.png') no-repeat center
    #eeeeee;
  cursor: pointer;
}
.items::-webkit-scrollbar-button:vertical:single-button:end {
  background: url('../../../components/edoovo-components/TableNew/Down Arrow.png') no-repeat center
    #eeeeee;
  cursor: pointer;
}

.mentionList .item {
  margin: 0;
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: #33475b;
  font-family: OpenSans;
  font-size: 14px;
  padding: 8px 8px;
  background: #fff;
  &:hover {
    background-color: #dfe3eb;
  }

  &.is-selected {
    background-color: #dfe3eb;
  }
}
.mentionList .itemNo {
  height: 63px;
  &:hover {
    background-color: #fff;
  }
}
</style>
